import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import {
  Box,
  Grid,
  Card,
  CardMedia,
  CardActions,
  IconButton,
  CircularProgress,
  Pagination,
  Stack,
} from '@mui/material';

import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { Button } from 'react-admin';

const API_URL = import.meta.env.VITE_API_URL;
const IMAGE_URL = import.meta.env.VITE_IMAGE_URL;

interface Carousel {
  productsCarouselId: number;
  image: string;
  imageBigger: string;
}

const CarouselList: React.FC = () => {
  const [carousels, setCarousels] = React.useState<Carousel[]>([]);
  const [loading, setLoading] = React.useState(true);
  const [page, setPage] = React.useState(1);
  const [totalPages, setTotalPages] = React.useState(1);
  const navigate = useNavigate();
  const rowsPerPage = 10;

  const fetchCarousels = () => {
    setLoading(true);
    axios
      .get(`${API_URL}/carousel?page=${page}&perPage=${rowsPerPage}`)
      .then((res) => {
        setCarousels(res.data.data ?? []);
        setTotalPages(res.data.pages ?? 1);
      })
      .catch(() => alert('Не вдалося завантажити каталог'))
      .finally(() => setLoading(false));
  };

  React.useEffect(() => {
    fetchCarousels();
  }, [page]);

  const handleDelete = async (id: number) => {
    if (!confirm('Видалити каталог?')) return;
    try {
      await axios.delete(`${API_URL}/carousel/${id}`);
      fetchCarousels();
    } catch {
      alert('Помилка при видаленні');
    }
  };

  if (loading) return <CircularProgress />;

  return (
    <Box sx={{ mx: 'auto', mt: 4 }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <h2>Каталоги</h2>
        <Button
          variant="contained"
          onClick={() => navigate('/carousele/new')}
          sx={{
            '& .MuiButton-startIcon': { margin: 0 },
            justifyContent: 'center',
          }}
        >
          Додати каталог
        </Button>
      </Box>
      <Grid container spacing={2}>
        {carousels.map((c) => (
          <Grid key={c.productsCarouselId} size={{ xs: 12, sm: 6, md: 4 }}>
            <Card>
              <CardMedia
                component="img"
                height="400"
                image={`${IMAGE_URL}${c.image}`}
                alt={`Carousel ${c.productsCarouselId}`}
              />
              <Box style={{ textAlign: 'center', marginTop: 5 }}>
                Унікальний код: {c.productsCarouselId}
              </Box>
              <CardActions sx={{ justifyContent: 'space-between' }}>
                <IconButton
                  onClick={() => navigate(`/carousel/${c.productsCarouselId}`)}
                >
                  <EditIcon />
                </IconButton>
                <IconButton onClick={() => handleDelete(c.productsCarouselId)}>
                  <DeleteIcon />
                </IconButton>
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>
      <Stack spacing={2} sx={{ mt: 3 }} alignItems="center">
        <Pagination
          count={totalPages}
          page={page}
          onChange={(_, value) => setPage(value)}
          color="primary"
        />
      </Stack>
    </Box>
  );
};

export default CarouselList;
